import React, { useState } from 'react';
import { SearchIcon, ExternalLinkIcon, LayoutIcon, FileTextIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function PagesTab() {
  const [searchQuery, setSearchQuery] = useState('');
  const pages = [{
    name: 'Home',
    path: '/',
    type: 'main'
  }, {
    name: 'About Us',
    path: '/about-us',
    type: 'main'
  }, {
    name: 'Contact Us',
    path: '/contact-us',
    type: 'main'
  }, {
    name: 'FAQ',
    path: '/faq',
    type: 'main'
  }, {
    name: 'Commercial Cleaning',
    path: '/commercial-cleaning',
    type: 'service'
  }, {
    name: 'Basic Home Cleaning',
    path: '/basic-home-cleaning',
    type: 'service'
  }, {
    name: 'Spring / Deep Cleaning',
    path: '/spring-deep-cleaning',
    type: 'service'
  }, {
    name: 'Commercial Quote',
    path: '/commercial-cleaning-quote',
    type: 'quote'
  }, {
    name: 'Basic Home Quote',
    path: '/basic-home-cleaning-quote',
    type: 'quote'
  }, {
    name: 'Move-In / Move-Out',
    path: '/move-in-move-out-quote',
    type: 'quote'
  }, {
    name: 'Airbnb / Short Term',
    path: '/airbnb-quote',
    type: 'quote'
  }, {
    name: 'Post Renovation',
    path: '/post-renovation-quote',
    type: 'quote'
  }, {
    name: 'Privacy Policy',
    path: '/privacy-policy',
    type: 'legal'
  }];
  const filteredPages = pages.filter(page => page.name.toLowerCase().includes(searchQuery.toLowerCase()) || page.path.toLowerCase().includes(searchQuery.toLowerCase()));
  const getIconForType = (type: string) => {
    switch (type) {
      case 'main':
        return <LayoutIcon className="w-4 h-4 text-blue-400" data-id="element-185" />;
      case 'service':
        return <LayoutIcon className="w-4 h-4 text-pink-400" data-id="element-186" />;
      case 'quote':
        return <FileTextIcon className="w-4 h-4 text-emerald-400" data-id="element-187" />;
      default:
        return <FileTextIcon className="w-4 h-4 text-slate-400" data-id="element-188" />;
    }
  };
  return <div className="flex flex-col h-full" data-id="element-189">
      <div className="p-4 border-b border-slate-800" data-id="element-190">
        <div className="relative" data-id="element-191">
          <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" data-id="element-192" />
          <input type="text" placeholder="Search pages..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full bg-slate-900 border border-slate-700 rounded-md py-2 pl-9 pr-3 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all" data-id="element-193" />
        </div>
      </div>

      <div className="flex-1 overflow-y-auto p-4" data-id="element-194">
        <div className="space-y-2" data-id="element-195">
          {filteredPages.map(page => <Link key={page.path} to={page.path} className="group flex items-center justify-between p-3 rounded-md bg-slate-800/50 hover:bg-slate-800 border border-slate-800 hover:border-slate-700 transition-all" data-id="element-196">
              <div className="flex items-center gap-3" data-id="element-197">
                <div className="p-1.5 bg-slate-900 rounded border border-slate-700" data-id="element-198">
                  {getIconForType(page.type)}
                </div>
                <div data-id="element-199">
                  <div className="text-sm font-medium text-slate-200 group-hover:text-white transition-colors" data-id="element-200">
                    {page.name}
                  </div>
                  <div className="text-xs text-slate-500 font-mono" data-id="element-201">
                    {page.path}
                  </div>
                </div>
              </div>
              <ExternalLinkIcon className="w-4 h-4 text-slate-600 group-hover:text-blue-400 transition-colors" data-id="element-202" />
            </Link>)}
        </div>
      </div>
    </div>;
}